import { createFileRoute } from '@tanstack/react-router'

import PublicOrg from 'pages/PublicOrg'

export const Route = createFileRoute('/public/orgs/$id')({
  component: PublicOrg,
})
